import styles from "../../styles/footer.module.scss";

const Footer = () => (
  <div className={styles.footer_container}>
    <div className={styles.footer_menu} id={styles.responsive_padding}>
      <a href="/"> ALL ACTIVITIES</a>
      <a href="/"> ABOUT US</a>
      <a href="/"> CONTACT US</a>
    </div>
    <div id={styles.responsive_padding}>
      <p>Copyright © 2020 Harty. All rights reserved.</p>
    </div>
  </div>
);

export default Footer;
